export enum UnlockMode {
  biometrics = 'Biometrics',
  biometricsWithPasscode = 'BiometricsWithPasscode',
  systemPasscode = 'SystemPasscode',
  secureStorage = 'SecureStorage',
}
